/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjects_Subject_Sports14Inputs */

const en__field__enum_teachingsubjects_subject_sports14 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_Sports14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sports`)
};

const de__field__enum_teachingsubjects_subject_sports14 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_Sports14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sport`)
};

/**
* | output |
* | --- |
* | "Sports" |
*
* @param {_Field__Enum_Teachingsubjects_Subject_Sports14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjects_subject_sports14 = /** @type {((inputs?: _Field__Enum_Teachingsubjects_Subject_Sports14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjects_Subject_Sports14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjects_subject_sports14(inputs)
	return de__field__enum_teachingsubjects_subject_sports14(inputs)
});
export { _field__enum_teachingsubjects_subject_sports14 as "_field__enum_teachingSubjects_SUBJECT_SPORTS" }